export enum ECalendar {
  classic,
  easy
}
